import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-nav-top',
    templateUrl: './nav-top.component.html',
    styleUrl: './nav-top.component.scss',
    standalone: false
})
export class NavTopComponent {
  @Input() title = '';
}
